import { CommonEntrypoint } from 'entrypoint/CommonEntrypoint';
import 'presentation/style/index.scss';
import UserGroupContMain from 'presentation/view/container/UserGroup/UserGroupContMain';

CommonEntrypoint(<UserGroupContMain/>)